// extracted by mini-css-extract-plugin
export default {"transfer":"Transfer_transfer__FGH2t"};